import { config } from "../../Config";

const GetAllAdmins = async (adminUserId) => {
  if (!adminUserId) {
    return { success: false, error: "Missing adminUserId", admins: [] };
  }
  try {
    const url = `${config.getAllAdmins}${config.getAllAdmins.includes("?") ? "&" : "?"}adminUserId=${encodeURIComponent(adminUserId)}`;
    const res = await fetch(url, { method: "GET" });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      return { success: false, error: data.error || `HTTP ${res.status}`, admins: [] };
    }
    return { success: true, admins: Array.isArray(data.admins) ? data.admins : [] };
  } catch (e) {
    return { success: false, error: e.message, admins: [] };
  }
};

export default GetAllAdmins;
